class App {
  constructor() {
    this.latestLeadTimeStr = null;
    this.init();
  }

  init() {
    this.setVariables();
    this.scrollTo();

    window.theme = window.theme || {};
    window.theme.formatMoney = this.formatMoney;

    // this.updateCartLeadTime();
    this.updateCartLeadTimeFromHTML();
    this.localizeLeadTimeElements();
    this.updateReturnUrls();

    ["mouseenter", "touchstart"].forEach(eventType => {
      document.addEventListener(
        eventType,
        e => {
          if (e.target && e.target.closest) {
            const link = e.target.closest('a[href*="return_url"]');
            if (link) {
              this.updateReturnUrl(link);
            }
          }
        },
        { passive: true }
      );
    });
  }

  async updateCartLeadTimeFromHTML() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      const cartItems = document.querySelectorAll("[data-cart-item]");
      if (cartItems.length === 0) return;

      const latestLeadTime = this.summarizeLeadTime(Array.from(cartItems), "liquid");
      const latestLeadTimeStr = latestLeadTime ? this.formatLeadTime(latestLeadTime.from, latestLeadTime.to) : "";

      this.latestLeadTimeStr = latestLeadTimeStr;
      this.updateLeadTimeUI(latestLeadTimeStr);

      if (cart.attributes.lead_time !== latestLeadTimeStr) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: { lead_time: latestLeadTimeStr } })
        });
      }
    } catch (error) {
      console.error("Error updating cart lead time attribute:", error);
    }
  }

  // async updateCartLeadTime() {
  //   try {
  //     const response = await fetch("/cart.js");
  //     const cart = await response.json();

  //     if (cart.items.length === 0) {
  //       if (cart.attributes.lead_time) {
  //         await fetch("/cart/update.js", {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify({ attributes: { lead_time: "" } })
  //         });
  //       }
  //       return;
  //     }

  //     const latestLeadTime = this.summarizeLeadTime(cart.items);
  //     const latestLeadTimeStr = latestLeadTime ? this.formatLeadTime(latestLeadTime.from, latestLeadTime.to) : "";

  //     this.latestLeadTimeStr = latestLeadTimeStr;
  //     this.updateLeadTimeUI(latestLeadTimeStr);

  //     if (cart.attributes.lead_time !== latestLeadTimeStr) {
  //       await fetch("/cart/update.js", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ attributes: { lead_time: latestLeadTimeStr } })
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error updating cart lead time attribute:", error);
  //   }
  // }

  summarizeLeadTime(items, type = "cart") {
    let latestTo = 0;
    let latestFrom = 0;

    items.forEach(item => {
      const toTs = type === "cart" ? parseInt(item.properties?.["_Lead Time Timestamp"]) || 0 : parseInt(item.dataset?.deliveryToTs) || 0;
      const fromTs = type === "cart" ? parseInt(item.properties?.["_Lead Time From"]) || 0 : parseInt(item.dataset?.deliveryFromTs) || 0;

      if (toTs > latestTo) {
        latestTo = toTs;
        latestFrom = fromTs;
      }
    });

    if (latestTo > 0 && latestFrom > 0) {
      return { from: latestFrom, to: latestTo };
    }
    return null;
  }

  formatLeadTime(fromTs, toTs) {
    const months = (window.messages?.months || "").split(",");
    if (months.length !== 12) return "";

    const fromDate = new Date(fromTs * 1000);
    const toDate = new Date(toTs * 1000);

    const fromDay = fromDate.getDate();
    const fromMonth = months[fromDate.getMonth()];
    const toDay = toDate.getDate();
    const toMonth = months[toDate.getMonth()];

    return `${fromDay} ${fromMonth} - ${toDay} ${toMonth}`;
  }

  localizeLeadTimeElements(root = document) {
    const elements = root.querySelectorAll("[data-lead-time]");
    elements.forEach(el => {
      const fromTs = parseInt(el.dataset.fromTs) || 0;
      const toTs = parseInt(el.dataset.toTs) || 0;

      if (fromTs > 0 && toTs > 0) {
        const localized = this.formatLeadTime(fromTs, toTs);
        if (localized) {
          // Preserve the original label if it contains a colon
          const originalText = el.textContent;
          if (originalText.includes(":")) {
            const label = originalText.split(":")[0];
            el.textContent = `${label}: ${localized}`;
          } else {
            el.textContent = localized;
          }
        }
      }
    });
  }

  updateReturnUrls(root = document) {
    root.querySelectorAll('a[href*="return_url"]').forEach(link => this.updateReturnUrl(link));
    root.querySelectorAll('form[action*="return_url"]').forEach(form => {
      try {
        const url = new URL(form.action, window.location.origin);
        if (url.searchParams.has("return_url") && !url.searchParams.get("return_url")) {
          url.searchParams.set("return_url", window.location.href);
          form.action = url.toString();
        }
      } catch (e) {
        console.error("Error updating return_url in form", e);
      }
    });
  }

  updateReturnUrl(link) {
    try {
      const url = new URL(link.href, window.location.origin);
      if (url.searchParams.has("return_url") && !url.searchParams.get("return_url")) {
        url.searchParams.set("return_url", window.location.href);
        link.href = url.toString();
      }
    } catch (e) {
      console.error("Error updating return_url", e);
    }
  }

  updateLeadTimeUI(leadTimeStr, root = document) {
    if (!leadTimeStr) return;
    const deliveryTimeElements = root.querySelectorAll(`
      .cart-drawer__summary-delivery-time button[drawer-trigger],
      .cart-main__summary-delivery-time button[drawer-trigger]
    `);

    deliveryTimeElements.forEach(el => {
      el.textContent = leadTimeStr;
    });
  }

  showHeaderMessage(message) {
    const header = document.querySelector(".header__main");
    const infoMessage = document.createElement("div");
    infoMessage.classList.add("header__info-message");
    infoMessage.textContent = message;
    header.appendChild(infoMessage);
    setTimeout(() => {
      infoMessage.classList.add("is-hiding");
      setTimeout(() => {
        infoMessage.remove();
      }, 150);
    }, 4000);
  }

  setVariables() {
    const topHeaderHeight = document.querySelector(".header-container__top").offsetHeight || 0;
    const mainHeaderHeight = document.querySelector(".header-container__main").offsetHeight || 0;

    document.documentElement.style.setProperty("--header-top-height", `${topHeaderHeight}px`);
    document.documentElement.style.setProperty("--header-main-height", `${mainHeaderHeight}px`);
    document.documentElement.style.setProperty("--header-height", `${topHeaderHeight + mainHeaderHeight}px`);
    document.documentElement.style.setProperty("--true-vw", `${document.documentElement.clientWidth}px`);
  }

  scrollTo() {
    document.addEventListener("click", e => {
      const scrollToElement = e.target.closest("[data-scroll-to]");

      if (!scrollToElement) return;

      e.preventDefault();

      const selector = scrollToElement.dataset.scrollTo;
      if (!selector) return;

      const targetElement = document.querySelector(selector);
      if (!targetElement) return;

      const targetHeight = targetElement.offsetHeight;
      const windowHeight = window.innerHeight;

      // If target is smaller than window, center it. Otherwise, align to start
      const scrollBehavior = targetHeight < windowHeight ? "center" : "start";

      targetElement.scrollIntoView({
        behavior: "smooth",
        block: scrollBehavior
      });
    });
  }

  formatMoney(cents) {
    const format = window.Shopify?.moneyFormat || "{{amount}} PLN";

    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);
      const parts = number.split(".");
      const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
      const cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholderRegex);
    if (!match) return cents;

    let value = "";
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  }

  renderWishlistCount(count) {
    const wishlistCount = document.querySelector("[data-wishlist-count]");
    if (wishlistCount) {
      wishlistCount.setAttribute("data-wishlist-count", count);
      wishlistCount.textContent = count;
    }
  }

  refresh() {
    this.setVariables();
  }
}

const app = new App();

window.addEventListener("resize", () => {
  app.refresh();
});
window.addEventListener("shopify:section:load", () => {
  app.refresh();
});
window.addEventListener("header-message", e => {
  app.showHeaderMessage(e.detail.message);
});
window.addEventListener("mib:wishlist:item-added", function (e) {
  app.showHeaderMessage(window.messages.added_to_wishlist);
});
window.addEventListener("mib:wishlist:item-removed", function (e) {
  app.showHeaderMessage(window.messages.removed_from_wishlist);
});
window.addEventListener("mib:wishlist:count", function (e) {
  app.renderWishlistCount(e.detail.count);
});

class DrawerElement extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector("[drawer-trigger]");
    this.closers = this.querySelectorAll("[drawer-close]");
    this.drawer = this.querySelector("dialog");

    this._handleCloserClick = this._handleCloserClick.bind(this);
    this._handleDrawerClick = this._handleDrawerClick.bind(this);
  }

  connectedCallback() {
    if (this.trigger) {
      this.trigger.addEventListener("click", e => {
        e.preventDefault();
        this.toggle();
      });
    }

    // Delivery time trigger
    const deliveryTimeTrigger = document.querySelector("[delivery-time-drawer-trigger]");
    if (this.classList.contains("cart-drawer__summary-delivery-time") && deliveryTimeTrigger) {
      deliveryTimeTrigger.addEventListener("click", e => {
        e.preventDefault();
        this.toggle();
      });
    }

    this.closers.forEach(closer => {
      closer.addEventListener("click", this._handleCloserClick);
    });

    if (this.drawer) {
      this.drawer.addEventListener("click", this._handleDrawerClick);
    }

    window.addEventListener("cart::open", () => {
      if (this.drawer.hasAttribute("data-cart-drawer")) {
        this.open();
      }
    });

    const urlParams = new URLSearchParams(window.location.search);
    const openSample = urlParams.get("open_sample");
    if (openSample) {
      const sampleToOpen = document.querySelector(`[data-fabric-sample="${openSample}"]`);
      if (sampleToOpen) {
        sampleToOpen.querySelector("[drawer-trigger]").click();
        setTimeout(() => {
          // remove the open_sample parameter from the url
          urlParams.delete("open_sample");
          window.history.replaceState({}, "", window.location.pathname + "?" + urlParams.toString());
        }, 100);
      }
    }
  }

  _handleCloserClick(event) {
    event.stopPropagation();
    event.preventDefault();

    const targetDialog = event.currentTarget.closest("dialog");
    if (targetDialog && targetDialog === this.drawer) this.close();
  }

  _handleDrawerClick(event) {
    if (event.target === this.drawer) this.close();
  }

  toggle() {
    if (this.drawer && this.drawer.open) this.close();
    else this.open();
  }

  close() {
    if (this.drawer) this.drawer.close();
  }

  open() {
    if (this.drawer) this.drawer.showModal();
  }

  showModal() {
    console.log("showModal");
  }
}
if (!customElements.get("drawer-element")) customElements.define("drawer-element", DrawerElement);

class MarketSwitcher extends DrawerElement {
  constructor() {
    super();

    this.triggers = document.querySelectorAll("[market-switcher-trigger]");

    this.languageOptions = this.querySelectorAll(`[name="market-switcher__language-input"]`);
    this.countryOptions = this.querySelectorAll(`[name="market-switcher__country-input"]`);

    this.form = this.querySelector("form");
    this.formSubmit = this.querySelector("[localization-switch]");
  }

  connectedCallback() {
    super.connectedCallback();

    this.triggers.forEach(trigger => {
      trigger.addEventListener("click", e => {
        e.preventDefault();
        this.open();
      });
    });

    this.languageOptions.forEach(option => {
      option.addEventListener("change", e => {
        e.preventDefault();
        this.form.language_code.value = e.target.value;
      });
    });

    this.countryOptions.forEach(option => {
      option.addEventListener("change", e => {
        e.preventDefault();
        this.form.country_code.value = e.target.value;
      });
    });

    this.formSubmit.addEventListener("click", e => {
      e.preventDefault();
      this.formSubmit.toggleAttribute("data-loading");
      this.form.submit();
    });
  }
}

if (!customElements.get("market-switcher")) customElements.define("market-switcher", MarketSwitcher);

class MegaMenu extends DrawerElement {
  constructor() {
    super();

    this.linksImages = this.querySelectorAll(".mega-menu__links-images img");
    this.linksImagesTriggers = this.querySelectorAll(".mega-menu__links a");
  }

  connectedCallback() {
    super.connectedCallback();

    this.linksImagesTriggers.forEach((link, index) => {
      link.addEventListener("mouseenter", () => {
        this.showImage(index);
      });
      link.addEventListener("mouseleave", () => {
        this.hideImage(index);
      });
    });
  }

  showImage(index) {
    this.linksImages.forEach((img, imgIndex) => {
      if (imgIndex === index) {
        img.classList.add("visible");
        setTimeout(() => {
          img.classList.add("fading-in");
        }, 10);
      }
    });
  }

  hideImage(index) {
    let duration = this.linksImages[index].style.getPropertyValue("--transition-duration") || "0.35s";
    if (duration.includes(".")) {
      duration = duration.replace("s", "");
      duration = parseFloat(duration) * 1000;
    }
    this.linksImages.forEach((img, imgIndex) => {
      if (imgIndex === index) {
        img.classList.remove("visible", "fading-in");
        img.classList.add("fading-out");
        setTimeout(() => {
          img.classList.remove("fading-out");
        }, duration);
      }
    });
  }
}

if (!customElements.get("mega-menu")) customElements.define("mega-menu", MegaMenu);

class MobileMenu extends DrawerElement {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }
}

if (!customElements.get("mobile-menu")) customElements.define("mobile-menu", MobileMenu);

class BuyButtons extends HTMLElement {
  constructor() {
    super();

    this.submit = this.querySelector('button[type="submit"]');
    this.form = this.form = this.querySelector("form") || this.closest("form");
    this.errorContainer = this.querySelector(".product-form__error-container");
    this.cartDrawer = document.querySelector("cart-drawer");
  }

  connectedCallback() {
    this.form?.addEventListener("submit", e => {
      e.preventDefault();
      this.setLoading(true);
      this.addToCart();
    });
  }

  setLoading(state) {
    this.submit.toggleAttribute("data-loading", state);
  }

  addToCart() {
    const formData = new FormData(this.form);

    if (!formData.get("id")) {
      console.error("Product ID not found in form");
      this.showError("Could not identify product. Please try again.");
      this.setLoading(false);
      return;
    }

    const body = JSON.stringify({
      items: [
        {
          id: formData.get("id"),
          quantity: parseInt(formData.get("quantity") || 1, 10),
          ...this.getFormProperties(formData)
        }
      ],
      sections: "cart-contents"
    });

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: body
    })
      .then(response => {
        if (!response.ok) {
          return response.json().then(data => {
            throw new Error(data.description || `Error: ${response.status}`);
          });
        }
        return response.json();
      })
      .then(data => {
        window.dispatchEvent(
          new CustomEvent("cart::update", {
            detail: {
              cartMessage: "added",
              cartContents: data.sections["cart-contents"]
            }
          })
        );
      })
      .catch(error => {
        console.error("Error adding to cart:", error);
        this.showError(error.message || "Could not add to cart. Please try again.");
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  getFormProperties(formData) {
    const properties = {};
    let hasProperties = false;

    for (const [key, value] of formData.entries()) {
      if (key.startsWith("properties[") && key.endsWith("]")) {
        const propertyName = key.slice(11, -1);
        properties[propertyName] = value;
        hasProperties = true;
      }
    }

    return hasProperties ? { properties } : {};
  }

  showError(message) {
    if (this.errorContainer) {
      this.errorContainer.textContent = message;
      setTimeout(() => {
        this.errorContainer.textContent = "";
      }, 3000);
    }
  }
}
if (!customElements.get("buy-buttons")) customElements.define("buy-buttons", BuyButtons);

class FabricSelector extends DrawerElement {
  constructor() {
    super();

    this.nameFilter = this.querySelector("input[name='name-filter']");
    this.typeFilters = this.querySelectorAll("input[name='type-filter']");
    this.colorFilters = this.querySelector("select[name='color-filter']");
    this.typeMobileFilters = this.querySelector("select[name='mobile-type-filter']");
    this.fabrics = this.querySelectorAll(".fabric-selector__fabric-list .product-option");
    this.confirmButtons = this.querySelectorAll("button[confirm-button]");

    this.fabricInfo = {
      name: this.querySelector("[fabric-information-title]"),
      image: this.querySelector(".fabric-selector__sample-image"),
      priceDiff: this.querySelector("[fabric-information-price-diff]"),
      type: this.querySelector("[fabric-information-type]"),
      composition: this.querySelector("[fabric-information-composition]"),
      grammage: this.querySelector("[fabric-information-grammage]"),
      resistance: this.querySelector("[fabric-information-resistance]"),
      features: {
        easyCleaning: this.querySelector('.fabric-selector__fabric-features__icon[data-feature="easy_cleaning"]'),
        petFriendly: this.querySelector('.fabric-selector__fabric-features__icon[data-feature="pet_friendly"]'),
        waterproof: this.querySelector('.fabric-selector__fabric-features__icon[data-feature="waterproof"]')
      }
    };

    this.galleryModel = document.querySelector("product-media model-element");
    this.selectorModel = this.querySelector("model-element");

    // Scroll-snap detection elements
    this.scrollContainer = this.querySelector(".fabric-selector__contents");
    this.sideSection = this.querySelector(".fabric-selector__side");
    this.previewSection = this.querySelector(".fabric-selector__preview");
    this.backButton = this.querySelector("[fabric-selector-back]");

    // Current view state: 'side' or 'preview'
    this.currentView = "side";
  }

  connectedCallback() {
    super.connectedCallback();

    this.filterFabrics = this.filterFabrics.bind(this);

    if (this.nameFilter) this.nameFilter.addEventListener("input", this.filterFabrics);
    if (this.typeFilters) {
      this.typeFilters.forEach(filter =>
        filter.addEventListener("change", e => {
          const value = e.target.value;
          const handleizedValue = value.toLowerCase().replace(/\s+/g, "-");
          const mobileSelectWrap = this.typeMobileFilters?.closest("select-input");
          if (mobileSelectWrap) {
            mobileSelectWrap.selectOption(handleizedValue);
          }
          this.filterFabrics();
        })
      );
    }
    if (this.typeMobileFilters) {
      this.typeMobileFilters.addEventListener("change", e => {
        const value = e.target.value;
        const desktopRadio = Array.from(this.typeFilters).find(radio => {
          const radioHandleized = radio.value.toLowerCase().replace(/\s+/g, "-");
          return radioHandleized === value || radio.value === value;
        });
        if (desktopRadio) {
          desktopRadio.checked = true;
        }
        this.filterFabrics();
      });
    }
    if (this.colorFilters) this.colorFilters.addEventListener("change", this.filterFabrics);

    this.fabrics.forEach(fabric => {
      fabric.addEventListener("click", e => {
        e.preventDefault();
        this.galleryModel?.updateModelFabric(fabric.getAttribute("model-option-code"));
        this.updateFabricData(fabric.dataset.variantId);
        this.markActiveFabric(fabric);

        // Auto-scroll to preview on mobile
        if (window.matchMedia("(max-width: 1023px)").matches) {
          this.scrollToPreview();
        }
      });
    });

    this.confirmButtons.forEach(button => {
      button.addEventListener("click", () => {
        const selectedVariantId = this.dataset.selectedVariantId;
        if (selectedVariantId) {
          const mainOption = document.querySelector(`.product-main__option-list .product-option[data-variant-id="${selectedVariantId}"]`);
          if (mainOption) {
            mainOption.click();
          }
        }
        this.close();
      });
    });

    // Setup mobile scroll observation
    this.setupScrollObservation();

    // Back button click handler
    if (this.backButton) {
      this.backButton.addEventListener("click", () => {
        this.scrollToSide();
      });
    }

    if (this.drawer) {
      this.drawer.addEventListener("close", () => this.handleDrawerClose());
    }
  }

  open() {
    this.markActiveFabric();
    this.updateFabricData(String(window.currentVariant));
    this.scrollToSide();

    if (this.drawer) this.drawer.showModal();

    if (this.galleryModel) {
      this.galleryModel.kill();
    }

    if (this.selectorModel) {
      if (this.galleryModel) {
        if (this.galleryModel.dataset.fabric) {
          this.selectorModel.dataset.fabric = this.galleryModel.dataset.fabric;
        }
        if (this.galleryModel.dataset.legs) {
          this.selectorModel.dataset.legs = this.galleryModel.dataset.legs;
        }
        if (this.galleryModel.dataset.veneer) {
          this.selectorModel.dataset.veneer = this.galleryModel.dataset.veneer;
        }
      }

      this.selectorModel.style.display = "block";
      this.selectorModel.init();
    }
  }

  close() {
    if (this.drawer && this.drawer.open) this.drawer.close();
  }

  handleDrawerClose() {
    if (this.selectorModel) {
      this.selectorModel.kill();
    }

    if (this.galleryModel) {
      if (this.selectorModel) {
        if (this.selectorModel.dataset.fabric) {
          this.galleryModel.dataset.fabric = this.selectorModel.dataset.fabric;
        }
        if (this.selectorModel.dataset.legs) {
          this.galleryModel.dataset.legs = this.selectorModel.dataset.legs;
        }
      }
      this.galleryModel.init();
    }
  }

  markActiveFabric(activeFabric) {
    const targetFabric = activeFabric || this.querySelector(`.product-option[data-variant-id="${window.currentVariant}"]`);

    this.fabrics.forEach(fabric => {
      fabric.classList.remove("product-option--active");
      fabric.querySelector(".swatch").classList.remove("swatch--active");
    });
    targetFabric?.classList.add("product-option--active");
    targetFabric?.querySelector(".swatch").classList.add("swatch--active");
  }

  updateFabricData(variantId) {
    const variantData = window.productOptions.find(option => option.variant.id === variantId);
    if (!variantData.fabric) return;

    const currentVariant = window.productOptions.find(option => option.variant.id === String(window.currentVariant));

    this.fabricInfo.name.textContent = variantData.fabric.name;
    this.fabricInfo.type.textContent = variantData.fabric.type;
    this.fabricInfo.composition.textContent = variantData.fabric.composition;
    this.fabricInfo.grammage.textContent = variantData.fabric.grammage;
    this.fabricInfo.resistance.textContent = variantData.fabric.resistance;

    const difference = currentVariant.variant.price - variantData.variant.price;
    this.fabricInfo.priceDiff.textContent = difference > 0 ? `(${window.theme.formatMoney(difference * -1)})` : difference < 0 ? `(+${window.theme.formatMoney(difference * -1)})` : `(${this.fabricInfo.priceDiff.dataset.noDiff})`;

    this.fabricInfo.image.innerHTML = variantData.fabric.image;

    // Animate image
    const img = this.fabricInfo.image.querySelector("img");
    if (img) {
      img.style.opacity = "0";
      img.style.transition = "opacity .3s ease-in";
      img.onload = () => {
        img.style.opacity = "1";
      };
    }
    this.dataset.selectedVariantId = variantId;

    const updateFeature = (element, isVisible) => {
      if (isVisible) {
        element.classList.remove("hidden");
        requestAnimationFrame(() => {
          element.style.opacity = "0";
          element.style.transition = "opacity .3s ease-in";
          requestAnimationFrame(() => {
            element.style.opacity = "1";
          });
        });
      } else {
        element.style.transition = "";
        element.style.opacity = "";
        element.classList.add("hidden");
      }
    };

    updateFeature(this.fabricInfo.features.easyCleaning, variantData.fabric.features.easy_cleaning != "false");
    updateFeature(this.fabricInfo.features.petFriendly, variantData.fabric.features.pet_friendly != "false");
    updateFeature(this.fabricInfo.features.waterproof, variantData.fabric.features.waterproof != "false");
  }

  filterFabrics() {
    const nameValue = this.nameFilter ? this.nameFilter.value.toLowerCase().trim() : "";
    const typeValue = Array.from(this.typeFilters).find(radio => radio.checked)?.value || "";
    const typeMobileValue = this.typeMobileFilters ? this.typeMobileFilters.value : "";
    const colorValue = this.colorFilters ? this.colorFilters.value : "";

    const activeType = typeMobileValue || typeValue;

    this.fabrics.forEach(fabric => {
      const name = fabric.dataset.name.toLowerCase();
      const type = fabric.dataset.type;
      const typeHandleized = type.toLowerCase().replace(/\s+/g, "-");
      const color = fabric.dataset.color;

      const matchesName = name.includes(nameValue);
      const matchesType = activeType === "" || type === activeType || typeHandleized === activeType;
      const matchesColor = colorValue === "" || color === colorValue;

      if (matchesName && matchesType && matchesColor) {
        fabric.style.display = "";
      } else {
        fabric.style.display = "none";
      }
    });
  }

  setupScrollObservation() {
    if (!this.scrollContainer || !this.previewSection) return;

    // Use IntersectionObserver to detect which section is in view
    this.scrollObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.target === this.previewSection && entry.isIntersecting) {
            this.setCurrentView("preview");
          } else if (entry.target === this.sideSection && entry.isIntersecting) {
            this.setCurrentView("side");
          }
        });
      },
      {
        root: this.scrollContainer,
        threshold: 0.5 // Element is considered "in view" when 50% visible
      }
    );

    // Observe both sections
    if (this.sideSection) this.scrollObserver.observe(this.sideSection);
    if (this.previewSection) this.scrollObserver.observe(this.previewSection);
  }

  setCurrentView(view) {
    if (this.currentView === view) return;

    this.currentView = view;

    // Toggle back button visibility
    if (this.backButton) {
      this.backButton.hidden = view !== "preview";
    }

    // Dispatch custom event for other components to react
    this.dispatchEvent(
      new CustomEvent("fabric-selector:view-change", {
        detail: { view },
        bubbles: true
      })
    );
  }

  scrollToSide() {
    if (this.sideSection && this.scrollContainer) {
      this.scrollContainer.scrollTo({
        left: 0,
        behavior: "smooth"
      });
    }
  }

  scrollToPreview() {
    if (this.previewSection && this.scrollContainer) {
      this.scrollContainer.scrollTo({
        left: this.scrollContainer.scrollWidth,
        behavior: "smooth"
      });
    }
  }
}
if (!customElements.get("fabric-selector")) customElements.define("fabric-selector", FabricSelector);

class ProductMain extends DrawerElement {
  constructor() {
    super();

    this.productMedia = this.querySelector("product-media");
    this.modelElement = document.querySelector(".main-carousel model-element");
    this.buyButtons = this.querySelector("buy-buttons form");

    this.fabricSelector = this.querySelector("fabric-selector");
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.productOptions = this.querySelectorAll(".product-option[data-name]:not(.fabric-selector__fabric-list .product-option)");

    this.productOptions.forEach(variant => {
      if (variant.hasAttribute("data-initialized")) return;
      variant.setAttribute("data-initialized", "true");

      variant.addEventListener("click", e => {
        e.preventDefault();
        this.handleVariantChange(variant);
      });
    });
  }

  markActiveVariant(variant) {
    const variantName = variant.dataset.name;
    const optionGroupElement = variant.closest(".product-main__option-group");

    const optionGroupCurrentNameElement = optionGroupElement.querySelector(".product-main__section-heading [variant-name]");
    if (optionGroupCurrentNameElement) optionGroupCurrentNameElement.innerHTML = variantName;

    const swatch = variant.querySelector(".swatch");
    const variants = variant.closest(".product-main__option-list").querySelectorAll(".product-option");

    variants.forEach(variant => {
      variant.classList.remove("product-option--active");
      variant.querySelector(".swatch").classList.remove("swatch--active");
    });
    variant.classList.add("product-option--active");
    swatch.classList.add("swatch--active");
  }

  setLoading(loading) {
    this.classList.toggle("is-loading", loading);
  }

  handleVariantChange(variant) {
    if (variant.getAttribute("data-variant-id") === this.currentVariantId) return;
    if (variant.getAttribute("data-variant-id")) {
      this.setLoading(true);
      fetch(window.location.pathname + `?variant=${variant.getAttribute("data-variant-id")}&sections=product-main`)
        .then(response => response.json())
        .then(data => {
          this.updateDynamicParts(data["product-main"]);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.setLoading(false);
        });
    } else {
      this.markActiveVariant(variant);
    }

    const variantOptionType = variant.getAttribute("model-option-type");
    if (this.modelElement) this.updateModel(variant, variantOptionType);
    if (this.fabricSelector && variant.getAttribute("data-variant-id")) {
      this.fabricSelector.updateFabricData(variant.getAttribute("data-variant-id"));
      window.currentVariant = variant.getAttribute("data-variant-id");
    }

    this.updateBuyButtons(variant);
    this.updateURL(variant);
  }

  updateDynamicParts(markup) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(markup, "text/html");

    const currentElements = {
      prices: this.querySelector(".product-main__price"),
      firstImage: this.querySelector("[dynamic-main-featured-slide]"),
      firstThumb: this.querySelector("[dynamic-thumb-featured-slide]"),
      modelThumb: this.querySelector("[dynamic-thumb-model-slide]"),
      dynamicOptions: this.querySelectorAll("[dynamic-option-group]"),
      buyButtons: this.querySelector(".product-main__buy-buttons"),
      modules: this.querySelector(".product-main__configuration")
    };

    const newElements = {
      prices: doc.querySelector(".product-main__price"),
      firstImage: doc.querySelector("[dynamic-main-featured-slide]"),
      modelThumb: doc.querySelector("[dynamic-thumb-model-slide]"),
      firstThumb: doc.querySelector("[dynamic-thumb-featured-slide]"),
      dynamicOptions: doc.querySelectorAll("[dynamic-option-group]"),
      buyButtons: doc.querySelector(".product-main__buy-buttons"),
      modules: doc.querySelector(".product-main__configuration")
    };

    if (currentElements.prices && newElements.prices) {
      currentElements.prices.innerHTML = newElements.prices.innerHTML;
    }
    if (currentElements.firstImage && newElements.firstImage) {
      currentElements.firstImage.innerHTML = newElements.firstImage.innerHTML;
    }
    if (currentElements.firstThumb && newElements.firstThumb) {
      currentElements.firstThumb.innerHTML = newElements.firstThumb.innerHTML;
    }
    if (currentElements.modelThumb && newElements.modelThumb) {
      currentElements.modelThumb.innerHTML = newElements.modelThumb.innerHTML;
    }
    if (currentElements.dynamicOptions && newElements.dynamicOptions) {
      currentElements.dynamicOptions.forEach((option, index) => {
        const newOption = newElements.dynamicOptions[index];
        if (newOption) {
          const innerSelectors = [".product-main__section-heading", ".product-main__swatch-list", ".product-main__link-list"];
          innerSelectors.forEach(selector => {
            const currentInner = option.querySelector(selector);
            const newInner = newOption.querySelector(selector);
            if (currentInner && newInner) {
              currentInner.innerHTML = newInner.innerHTML;
            }
          });
        }
      });
    }
    if (currentElements.buyButtons && newElements.buyButtons) {
      currentElements.buyButtons.innerHTML = newElements.buyButtons.innerHTML;
      this.buyButtons = this.querySelector("buy-buttons form");

      const activeLegFinishing = this.querySelector('.product-option[model-option-type="Leg Finishing"].product-option--active');
      if (activeLegFinishing) {
        this.updateBuyButtons(activeLegFinishing);
      }
    }
    if (currentElements.modules && newElements.modules) {
      currentElements.modules.innerHTML = newElements.modules.innerHTML;
    }

    this.init();
  }

  updateBuyButtons(variant) {
    const variant_id = variant.getAttribute("data-variant-id");
    if (variant_id) this.buyButtons.querySelector('input[name="id"]').value = variant_id;
    if (variant.getAttribute("model-option-type") === "Leg Finishing") {
      this.buyButtons.querySelector('input[name="properties[_Leg Finishing]"]').value = variant.dataset.name;
    }
  }

  updateModel(variant, variantOptionType) {
    let blockName = null;

    const variantOptionCode = variant.getAttribute("model-option-code");
    switch (variantOptionType) {
      case "Fabric finishing":
        blockName = "FabricFinishes";
        break;
      case "Leg Finishing":
        blockName = "LegFinishes";
        break;
      case "Veneer finishing":
        blockName = "Veneerfinishes"; // Mimeeq block code confirmed live on Cove after repin to shared "Veneers" library, 2026-06-29
        break;
    }
    this.modelElement.updateModel(blockName, variantOptionCode);
  }

  updatePrices(variant) {
    const variant_id = variant.getAttribute("variant-id");
    const variantData = window.productOptions.find(option => option.variant.id === variant_id);
    this.dynamicElements.price.textContent = variantData.price;
  }

  updateURL(variant) {
    const url = new URL(window.location);
    const variantId = variant.getAttribute("data-variant-id");

    if (variantId) {
      url.searchParams.set("variant", variantId);
    }

    if (variant.getAttribute("model-option-type") === "Leg Finishing") {
      const legName = variant.getAttribute("model-option-code");
      if (legName) {
        url.searchParams.set("legs", legName);
      } else {
        url.searchParams.delete("legs");
      }
    }

    window.history.replaceState(null, null, url);
  }
}
if (!customElements.get("product-main")) customElements.define("product-main", ProductMain);

class ModelElement extends HTMLElement {
  static scriptLoaded = false;
  static currentInstance = null;
  static selectedFabric = null;
  static selectedLegs = null;
  static selectedVeneer = null;

  constructor() {
    super();

    this.mimeeq = this.querySelector("mmq-embed");
    ModelElement.selectedFabric = this.dataset.fabric;
    ModelElement.selectedLegs = this.dataset.legs;
    ModelElement.selectedVeneer = this.dataset.veneer || null;
  }

  static async loadMimeeqScript() {
    return new Promise((resolve, reject) => {
      if (document.querySelector('script[src="https://cdn.mimeeq.com/read_models/embed/app-embed.js"]')) {
        resolve();
        return;
      }

      const script = document.createElement("script");
      script.src = "https://cdn.mimeeq.com/read_models/embed/app-embed.js";
      script.async = true;
      script.onload = () => {
        ModelElement.scriptLoaded = true;
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  static waitForMimeeq(timeout = 10000) {
    return new Promise((resolve, reject) => {
      if (window.mimeeqApp && window.mimeeqApp.actions) {
        resolve();
        return;
      }

      const startTime = Date.now();
      const checkInterval = setInterval(() => {
        if (window.mimeeqApp && window.mimeeqApp.actions) {
          clearInterval(checkInterval);
          resolve();
        } else if (Date.now() - startTime > timeout) {
          clearInterval(checkInterval);
          reject(new Error("Mimeeq App load timeout"));
        }
      }, 100);
    });
  }

  connectedCallback() {
    this.handleUrlParams();
    if (!this.closest("fabric-selector")) {
      this.init();
    }

    this.updateContainerHeight = this.updateContainerHeight.bind(this);
    this.updateContainerHeight();
    this.resizeObserver = new ResizeObserver(this.updateContainerHeight);
    this.resizeObserver.observe(this);

    // Debug: Listen to all Mimeeq events - left for debugging issues
    // const debugEvents = [
    //   "mimeeq-app-loaded",
    //   "mimeeq-3d-product-initialized",
    //   "mimeeq-select-option",
    //   "mimeeq-app-url-change",
    //   "mimeeq-embed-unmounted",
    //   "mmqBasketRendered",
    //   "mmqBasketHidden",
    //   "mimeeq-enter-product",
    //   "mimeeq-modular-select-option",
    //   "mimeeq-modular-select-option-multiple",
    //   "mimeeq-3d-before-export-image",
    //   "mimeeq-3d-after-export-image",
    //   "mimeeq-3d-before-export-scene",
    //   "mimeeq-3d-after-export-scene",
    //   "mimeeq-show-dimensions",
    //   "mimeeq-app-template-error"
    // ];

    // debugEvents.forEach(eventName => {
    //   document.addEventListener(eventName, e => {
    //     console.log(`%c[Mimeeq Event] ${eventName}`, "color: #00bcd4; font-weight: bold;", e.detail || e);
    //   });
    // });
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  updateContainerHeight() {
    if (this.closest(".fabric-selector__model") || this.closest(".main-carousel")) {
      const rect = this.getBoundingClientRect();
      const width = rect.width;
      const height = rect.height;

      const heightToSet = height > 0 && height / width < 2 / 3 ? height : width * (2 / 3);

      this.style.setProperty("--mmq-configurator-container-height", `${heightToSet}px`);
      this.style.setProperty("--mmq-canvas-height", `${heightToSet}px`);

      if (this.mimeeq) {
        this.mimeeq.style.setProperty("--mmq-configurator-container-height", `${heightToSet}px`);
        this.mimeeq.style.setProperty("--mmq-canvas-height", `${heightToSet}px`);
      }
    }
  }

  handleUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");
    const legCode = urlParams.get("legs");

    if (variantId && window.productOptions) {
      const domOption = document.querySelector(`.product-option[data-variant-id="${variantId}"][model-option-type="Fabric finishing"]`);
      if (domOption) {
        const mimeeqCode = domOption.getAttribute("model-option-code");
        if (mimeeqCode) {
          ModelElement.selectedFabric = mimeeqCode;
          this.dataset.fabric = mimeeqCode;
        }
      }
      const veneerOption = document.querySelector(`.product-option[data-variant-id="${variantId}"][model-option-type="Veneer finishing"]`);
      if (veneerOption) {
        const mimeeqVeneerCode = veneerOption.getAttribute("model-option-code");
        if (mimeeqVeneerCode) {
          ModelElement.selectedVeneer = mimeeqVeneerCode;
          this.dataset.veneer = mimeeqVeneerCode;
        }
      }
    }

    if (legCode) {
      const legOption = document.querySelector(`.product-option[model-option-code="${legCode}"][model-option-type="Leg Finishing"]`);
      if (legOption) {
        const productMain = this.closest("product-main");
        if (productMain) {
          productMain.markActiveVariant(legOption);
          productMain.updateBuyButtons(legOption);
        }
        ModelElement.selectedLegs = legCode;
        this.dataset.legs = legCode;
      }
    }
  }

  async init() {
    try {
      await ModelElement.loadMimeeqScript();
      await ModelElement.waitForMimeeq();

      if (!window.mimeeqApp.actions) {
        const loadPromise = new Promise(resolve => {
          const handler = () => {
            document.removeEventListener("mimeeq-3d-product-initialized", handler);
            resolve();
          };
          setTimeout(() => {
            document.removeEventListener("mimeeq-3d-product-initialized", handler);
            resolve();
          }, 2000);
          document.addEventListener("mimeeq-3d-product-initialized", handler);
        });

        await this.mimeeq.show();
        await loadPromise;
      } else {
        await this.mimeeq.show();
      }

      ModelElement.currentInstance = this;

      this.update();
      this.startVerificationLoop();
    } catch (error) {
      console.error("Mimeeq init error:", error);
    }
  }

  startVerificationLoop() {
    if (this.verificationInterval) clearInterval(this.verificationInterval);

    const startTime = Date.now();
    this.verificationInterval = setInterval(() => {
      const isSynced = this.verifyAndFixModel();
      if (isSynced || Date.now() - startTime > 30000) {
        clearInterval(this.verificationInterval);
        this.verificationInterval = null;
      }
    }, 1000);
  }

  verifyAndFixModel() {
    if (!window.mimeeqApp) return false;

    let allSynced = true;

    if (ModelElement.selectedFabric) {
      const currentFabric = this.getCurrentMimeeqOption("FabricFinishes");
      if (currentFabric !== ModelElement.selectedFabric) {
        window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode("FabricFinishes", ModelElement.selectedFabric);
        allSynced = false;
      }
    }

    if (ModelElement.selectedLegs) {
      const currentLegs = this.getCurrentMimeeqOption("LegFinishes");
      if (currentLegs !== ModelElement.selectedLegs) {
        window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode("LegFinishes", ModelElement.selectedLegs);
        allSynced = false;
      }
    }

    if (ModelElement.selectedVeneer) {
      const currentVeneer = this.getCurrentMimeeqOption("Veneerfinishes");
      if (currentVeneer !== ModelElement.selectedVeneer) {
        window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode("Veneerfinishes", ModelElement.selectedVeneer);
        allSynced = false;
      }
    }

    if (allSynced) {
      document.dispatchEvent(new CustomEvent("model:synced"));
    }

    return allSynced;
  }

  getCurrentMimeeqOption(blockName) {
    if (!window.mimeeqApp || !window.mimeeqApp.observers || !window.mimeeqApp.observers.optionSets || !window.mimeeqApp.observers.optionSets.selectedOptions) {
      return null;
    }

    let foundCode = null;
    const sub = window.mimeeqApp.observers.optionSets.selectedOptions.subscribe(data => {
      let items = null;

      if (data && data.newValue && data.newValue.SINGLE_PRODUCT_ID && Array.isArray(data.newValue.SINGLE_PRODUCT_ID)) {
        items = data.newValue.SINGLE_PRODUCT_ID;
      } else if (data && data.SINGLE_PRODUCT_ID && Array.isArray(data.SINGLE_PRODUCT_ID)) {
        items = data.SINGLE_PRODUCT_ID;
      }

      if (items) {
        const found = items.find(opt => opt.blockCode === blockName);
        if (found) foundCode = found.code;
      }
    });

    if (sub) sub.unsubscribe();
    return foundCode;
  }

  async update() {
    const options = [];

    if (ModelElement.selectedFabric) {
      options.push({ blockName: "FabricFinishes", optionCode: ModelElement.selectedFabric });
    }
    if (ModelElement.selectedLegs) {
      options.push({ blockName: "LegFinishes", optionCode: ModelElement.selectedLegs });
    }
    if (ModelElement.selectedVeneer) {
      options.push({ blockName: "Veneerfinishes", optionCode: ModelElement.selectedVeneer });
    }

    await this.updateCanvasSequentially(options);
  }

  async updateCanvasSequentially(options) {
    if (!window.mimeeqApp || !options || options.length === 0) return;

    for (let i = 0; i < options.length; i++) {
      const { blockName, optionCode } = options[i];
      let sub;

      await new Promise(resolve => {
        sub = window.mimeeqApp.observers.optionSets.selectedOptions.subscribe(data => {
          let hasEntry;

          if (data.SINGLE_PRODUCT_ID && Array.isArray(data.SINGLE_PRODUCT_ID)) {
            hasEntry = data.SINGLE_PRODUCT_ID.find(selectedOption => selectedOption.blockCode === blockName && selectedOption.code === optionCode);
          }

          if (data.newValue || hasEntry) {
            resolve(true);
          }
        });

        window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(blockName, optionCode);
      });

      if (sub) {
        sub.unsubscribe();
      }
    }
  }

  async kill() {
    if (this.verificationInterval) clearInterval(this.verificationInterval);
    if (this.mimeeq) {
      await this.mimeeq.hide();
    }
    if (ModelElement.currentInstance === this) {
      ModelElement.currentInstance = null;
    }
  }

  updateModelFabric(mimeeqFabricCode) {
    if (!mimeeqFabricCode) return;
    window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode("FabricFinishes", mimeeqFabricCode);
  }

  updateModel(blockName, optionCode) {
    if (!window.mimeeqApp) return;

    if (blockName === "FabricFinishes") {
      ModelElement.selectedFabric = optionCode;
      this.dataset.fabric = optionCode;
    } else if (blockName === "LegFinishes") {
      ModelElement.selectedLegs = optionCode;
      this.dataset.legs = optionCode;
    } else if (blockName === "Veneerfinishes") {
      ModelElement.selectedVeneer = optionCode;
      this.dataset.veneer = optionCode;
    }

    this.update();
  }
}
if (!customElements.get("model-element")) customElements.define("model-element", ModelElement);

class ModelControls extends HTMLElement {
  constructor() {
    super();

    this.currentPosition = "CL";
    this.positionButton = this.querySelector("[model-open]");
    this.arButton = this.querySelector("[model-ar]");

    this.swiperSibling = this.parentElement.querySelector("swiper-container");

    if (this.positionButton) this.positionButton.addEventListener("click", () => this.updateModelPosition());
    if (this.arButton)
      this.arButton.addEventListener("click", () => {
        this.showAR();
      });
  }

  connectedCallback() {
    document.addEventListener("model:synced", () => {
      this.setVisible();
    });

    if (this.swiperSibling) {
      this.swiperSibling.addEventListener("swiperslidechange", e => {
        const [swiper] = e.detail;
        if (swiper.activeIndex == 0) console.log("current slide: ", swiper.activeIndex);
      });
    }
  }

  setVisible() {
    this.classList.add("model-controls--is-visible");
  }

  setHidden() {
    this.classList.remove("model-controls--is-visible");
  }

  updateModelPosition() {
    if (!window.mimeeqApp) return;
    this.positionButton.toggleAttribute("data-loading");
    const newPosition = this.currentPosition == "CL" ? "OP" : "CL";
    const label = this.positionButton.querySelector("span");
    label.textContent = newPosition == "CL" ? this.positionButton.dataset.labelOpen : this.positionButton.dataset.labelClose;
    window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode("Position", newPosition).then(() => this.positionButton.removeAttribute("data-loading"));
    this.currentPosition = newPosition;
  }

  showAR() {
    if (!window.mimeeqApp) return;
    this.arButton.toggleAttribute("data-loading");
    window.mimeeqApp.actions.showAR().then(() => this.arButton.removeAttribute("data-loading"));
  }
}
if (!customElements.get("model-controls")) customElements.define("model-controls", ModelControls);

class HoverableCollections extends HTMLElement {
  constructor() {
    super();

    this.items = this.querySelectorAll(".hoverable-collection");
    this.activeItem = null;
  }

  connectedCallback() {
    this.items.forEach(item => {
      item.addEventListener("mouseenter", () => {
        this.activeItem = item;
        const img = item.querySelector("img");
        img.style.display = "block";
      });

      item.addEventListener("mouseleave", () => {
        const img = item.querySelector("img");
        img.style.display = "none";
        this.activeItem = null;
      });

      item.addEventListener("mousemove", e => {
        if (this.activeItem === item) {
          this.updateImagePosition(item, e);
        }
      });
    });
  }

  updateImagePosition(item, e) {
    const img = item.querySelector("img");
    const x = e.clientX;
    const y = e.clientY;
    const offsetX = img.offsetHeight / 2;
    const offsetY = -img.offsetHeight / 2;

    img.style.top = `${y + offsetY}px`;
    img.style.left = `${x + offsetX}px`;

    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const imgRect = img.getBoundingClientRect();

    if (x + offsetX + imgRect.width > viewportWidth) {
      img.style.left = `${x - offsetX - imgRect.width}px`;
    }

    if (y + offsetY + imgRect.height > viewportHeight) {
      img.style.top = `${y - offsetY - imgRect.height}px`;
    }
  }
}
if (!customElements.get("hoverable-collections")) customElements.define("hoverable-collections", HoverableCollections);

class FabricTooltip extends HTMLElement {
  constructor() {
    super();

    this.parentFabricElement = this.closest(".fabric-card");
    this.supportsHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    // Bound, debounced handlers stored so they can be removed in disconnectedCallback
    this._onMouseEnter = () => this.calculatePosition();
    this._onResize = this._debounce(() => this.calculatePosition(), 100);
    this._onSlideChanged = this._debounce(() => this.calculatePosition(), 100);
  }

  connectedCallback() {
    if (this.supportsHover && this.parentFabricElement) {
      this.parentFabricElement.addEventListener("mouseenter", this._onMouseEnter);
    }

    window.addEventListener("resize", this._onResize);
    window.addEventListener("fabric-carousel:slide-changed", this._onSlideChanged);
  }

  disconnectedCallback() {
    if (this.supportsHover && this.parentFabricElement) {
      this.parentFabricElement.removeEventListener("mouseenter", this._onMouseEnter);
    }

    window.removeEventListener("resize", this._onResize);
    window.removeEventListener("fabric-carousel:slide-changed", this._onSlideChanged);
  }

  _debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

  calculatePosition() {
    this.style.left = "";

    const rect = this.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const margin = 16;

    if (rect.right > viewportWidth - margin) {
      const overflow = rect.right - (viewportWidth - margin);
      const currentLeft = parseFloat(getComputedStyle(this).left) || -16;
      this.style.left = `${currentLeft - overflow}px`;
    }
  }
}
if (!customElements.get("fabric-tooltip")) customElements.define("fabric-tooltip", FabricTooltip);

class FabricCarousel extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector("swiper-container");
  }

  connectedCallback() {
    this.addCarouselParameters();
  }

  addCarouselParameters() {
    Object.assign(this.carousel, {
      slidesPerView: "auto",
      watchSlidesProgress: true,
      spaceBetween: 6,
      grabCursor: true,
      centeredSlides: true,
      initialSlide: 0,
      navigation: {
        nextEl: this.querySelector("[data-swiper-next]"),
        prevEl: this.querySelector("[data-swiper-prev]")
      },
      breakpoints: {
        992: {
          spaceBetween: 8,
          centeredSlides: true
        }
      },
      loop: true,
      on: {
        init: swiper => {
          swiper.el.style.overflow = "visible";

          if (window.innerWidth < 992) {
            swiper.params.centeredSlides = false;
            swiper.update();
          }
        },
        transitionEnd: swiper => {
          const activeSlide = swiper.slides[swiper.activeIndex];
          const card = activeSlide && activeSlide.querySelector(".fabric-card");
          const title = card && card.querySelector(".fabric-card__title") ? card.querySelector(".fabric-card__title").textContent.trim() : "";
          const tooltipEl = card && card.querySelector("fabric-tooltip");
          const description = tooltipEl ? tooltipEl.textContent.trim() : "";
          window.dispatchEvent(
            new CustomEvent("fabric-carousel:slide-changed", {
              detail: { title, description }
            })
          );
        }
      }
    });

    this.carousel.initialize();
  }
}
if (!customElements.get("fabrics-carousel")) customElements.define("fabrics-carousel", FabricCarousel);

class FabricMobileInfo extends HTMLElement {
  constructor() {
    super();
    this._isTouch = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
    this._onSlideChanged = e => this._update(e.detail);
  }

  connectedCallback() {
    if (!this._isTouch) return;
    window.addEventListener("fabric-carousel:slide-changed", this._onSlideChanged);
  }

  disconnectedCallback() {
    window.removeEventListener("fabric-carousel:slide-changed", this._onSlideChanged);
  }

  _update({ title, description } = {}) {
    if (!title && !description) return;
    this.innerHTML = `<p class="h6 uppercase t-bold">${title}</p><p class="t-small">${description}</p>`;
    this.removeAttribute("data-empty");
  }
}
if (!customElements.get("fabric-mobile-info")) customElements.define("fabric-mobile-info", FabricMobileInfo);

class FeaturedCollection extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector("swiper-container");
  }

  connectedCallback() {
    this.addCarouselParameters();
  }

  addCarouselParameters() {
    Object.assign(this.carousel, {
      slidesPerView: "auto",
      watchSlidesProgress: true,
      spaceBetween: 40,
      grabCursor: true,
      loop: true,
      navigation: {
        nextEl: this.querySelector("[data-swiper-next]"),
        prevEl: this.querySelector("[data-swiper-prev]")
      },
      on: {
        init: swiper => {
          swiper.el.style.overflow = "visible";

          if (window.innerWidth < 992) {
            swiper.update();
          }
        }
      }
    });

    this.carousel.initialize();
  }
}
if (!customElements.get("featured-collection")) customElements.define("featured-collection", FeaturedCollection);

class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.main_carousel = this.querySelector("swiper-container.main-carousel");
    this.thumb_carousel = this.querySelector("swiper-container.thumb-carousel");
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this.main_carousel) this.addMainCarouselParameters();
    if (this.thumb_carousel) this.addThumbCarouselParameters();
  }

  addMainCarouselParameters() {
    const handleTouchMoves = (slide, swiper) => {
      if (slide.classList.contains("has-model-element")) {
        if (swiper.activeIndex === 0) {
          swiper.allowTouchMove = false;
        } else {
          swiper.allowTouchMove = true;
        }
      }
    };

    Object.assign(this.main_carousel, {
      slidesPerView: 1,
      spaceBetween: 40,
      grabCursor: true,
      centeredSlides: true,
      autoHeight: true,
      thumbs: {
        swiper: this.thumb_carousel
      },
      navigation: {
        nextEl: this.querySelector(".main-carousel__carousel-nav .carousel-navigation__next"),
        prevEl: this.querySelector(".main-carousel__carousel-nav .carousel-navigation__prev")
      },
      noSwiping: true,
      noSwipingClass: "swiper-no-swiping",
      on: {
        init: swiper => {
          const modelElementSlide = swiper.slides[0].querySelector("model-element");
          if (modelElementSlide) {
            handleTouchMoves(swiper.slides[0], swiper);
          }
        },
        slideChange: swiper => {
          const modelElementSlide = swiper.slides[0].querySelector("model-element");
          if (modelElementSlide) {
            handleTouchMoves(swiper.slides[0], swiper);
          }
        }
      }
    });

    this.main_carousel.initialize();
  }

  addThumbCarouselParameters() {
    Object.assign(this.thumb_carousel, {
      slidesPerView: "auto",
      spaceBetween: 8,
      watchSlidesProgress: true
    });

    this.thumb_carousel.initialize();
  }
}
if (!customElements.get("product-media")) customElements.define("product-media", ProductMedia);

class SubCollectionsCarousel extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector("swiper-container");
  }

  connectedCallback() {
    this.initCarousel();
  }

  initCarousel() {
    Object.assign(this.carousel, {
      slidesPerView: 2.3,
      spaceBetween: 0,
      grabCursor: true,
      initialSlide: 0,
      breakpoints: {
        480: {
          slidesPerView: 3.1
        },
        768: {
          slidesPerView: 3.7
        },
        1200: {
          slidesPerView: 4.5
        },
        1400: {
          slidesPerView: 6
        }
      },
      on: {
        init: swiper => {
          this.carousel.classList.add("is-initialized");
          swiper.el.style.overflow = "visible";
        }
      }
    });

    this.carousel.initialize();
  }
}
if (!customElements.get("sub-collections-carousel")) customElements.define("sub-collections-carousel", SubCollectionsCarousel);

class TeamCarousel extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector("swiper-container");
    this.teamInfosHld = this.querySelector("[data-team-infos-hld]");
    this.teamInfos = this.querySelector("[data-team-infos]");
    this.teamInfoItems = this.querySelectorAll("[data-team-info]");
    this.teamMembers = this.querySelectorAll("[data-team-member]");
  }

  connectedCallback() {
    this.addCarouselParameters();
    this.calculateHighestDescriptionHeight();

    window.addEventListener("resize", () => {
      this.calculateHighestDescriptionHeight();
      this.updateTeamInfosTranslate();
    });
  }

  updateTeamInfosTranslate() {
    const teamMembersArray = Array.from(this.teamMembers);
    const activeTeamMember = teamMembersArray.find(member => member.dataset.isActive === "true");
    const activeTeamMemberRect = activeTeamMember.getBoundingClientRect();
    // set the translateX to active team member position regard to window, but not more than container width - current description width
    const translateX = Math.min(activeTeamMemberRect.left, this.teamInfosHld.offsetWidth - this.teamInfos.offsetWidth);
    this.teamInfos.style.setProperty("--translate-x", `${translateX}px`);
  }

  calculateHighestDescriptionHeight() {
    let highestDescriptionHeight = 0;
    this.teamInfoItems.forEach(info => {
      const height = info.offsetHeight;
      if (height > highestDescriptionHeight) {
        highestDescriptionHeight = height;
      }
    });
    this.teamInfos.style.setProperty("--highest-description-height", `${highestDescriptionHeight}px`);
  }

  addCarouselParameters() {
    Object.assign(this.carousel, {
      slidesPerView: 3.2,
      grabCursor: true,
      initialSlide: 0,
      breakpoints: {
        768: {
          slidesPerView: "auto"
        },
        1280: {
          slidesPerView: "auto"
        },
        1440: {
          slidesPerView: 8
        }
      },
      on: {
        init: swiper => {
          swiper.slides.forEach(slide => {
            ["mouseenter", "touchstart"].forEach(event => {
              slide.addEventListener(event, () => {
                swiper.slides.forEach(s => (s.dataset.isActive = false));
                slide.dataset.isActive = true;
                this.teamInfoItems.forEach(info => {
                  info.setAttribute("data-is-active", false);
                  if (info.dataset.teamInfo === slide.dataset.teamMember) {
                    info.setAttribute("data-is-active", true);
                  }
                });
                this.updateTeamInfosTranslate();
              });
            });
          });
        }
      }
    });

    this.carousel.initialize();
    this.updateTeamInfosTranslate();
  }
}
if (!customElements.get("team-carousel")) customElements.define("team-carousel", TeamCarousel);

class UspsCarousel extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector("swiper-container");
    this.maxSlides = this.querySelectorAll("swiper-slide").length > 3 ? 3.4 : 3;
  }

  connectedCallback() {
    this.addCarouselParameters();
  }

  addCarouselParameters() {
    Object.assign(this.carousel, {
      slidesPerView: 1.25,
      grabCursor: true,
      initialSlide: 0,
      spaceBetween: 20,
      breakpoints: {
        480: {
          slidesPerView: 1.5
        },
        768: {
          slidesPerView: 2.2
        },
        1024: {
          slidesPerView: 2.7
        },
        1280: {
          slidesPerView: this.maxSlides
        }
      }
    });

    this.carousel.initialize();
  }
}
if (!customElements.get("usps-carousel")) customElements.define("usps-carousel", UspsCarousel);

class SelectInput extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.nativeSelect = this.querySelector("select");
    this.displayLabel = this.querySelector(".select-input__label");
    this.displayValue = this.querySelector(".select-input__value");
    this.optionButtons = this.querySelectorAll("[data-value]");

    this.activeIndex = -1;
    this.focusableElements = [];
    this.placeholder = this.displayValue?.getAttribute("data-placeholder") || "";

    this._handleToggle = this._handleToggle.bind(this);
    this._handleKeydown = this._handleKeydown.bind(this);
    this._handleOptionClick = this._handleOptionClick.bind(this);
    this._handleGlobalOpen = this._handleGlobalOpen.bind(this);
    this._trapFocus = this._trapFocus.bind(this);
  }

  connectedCallback() {
    if (this.nativeSelect?.value) {
      this.updateDisplay(this.nativeSelect.value);
    }

    this.details.addEventListener("toggle", this._handleToggle);
    window.addEventListener("select-input:open", this._handleGlobalOpen);
    this.addEventListener("keydown", this._handleKeydown);

    this.optionButtons.forEach((button, index) => {
      button.addEventListener("click", this._handleOptionClick);

      if (this.nativeSelect && button.dataset.value === this.nativeSelect.value) {
        this.activeIndex = index;
      }
    });

    this.updateFocusableElements();
  }

  disconnectedCallback() {
    this.details.removeEventListener("toggle", this._handleToggle);
    window.removeEventListener("select-input:open", this._handleGlobalOpen);
    this.removeEventListener("keydown", this._handleKeydown);

    this.optionButtons.forEach(button => {
      button.removeEventListener("click", this._handleOptionClick);
    });
  }

  _handleGlobalOpen(event) {
    if (event.detail.target !== this && this.details.open) {
      this.close();
    }
  }

  _handleToggle(event) {
    if (this.details.open) {
      this.onOpen();
    } else {
      this.onClose();
    }
  }

  _handleKeydown(event) {
    if (!this.details.open) return;

    const { key } = event;

    switch (key) {
      case "ArrowDown":
        event.preventDefault();
        this.moveActiveIndex(1);
        break;
      case "ArrowUp":
        event.preventDefault();
        this.moveActiveIndex(-1);
        break;
      case "Home":
        event.preventDefault();
        this.setActiveIndex(0);
        break;
      case "End":
        event.preventDefault();
        this.setActiveIndex(this.optionButtons.length - 1);
        break;
      case "Enter":
      case " ":
        if (event.target === this.summary) return;
        event.preventDefault();
        this.selectActiveOption();
        break;
      case "Escape":
        event.preventDefault();
        this.close();
        break;
      case "Tab":
        this._trapFocus(event);
        break;
      default:
        if (key.length === 1) {
          this.handleTypeAhead(key);
        }
        break;
    }
  }

  _handleOptionClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const value = button.dataset.value;
    const label = button.textContent.trim();

    this.selectOption(value, label);
  }

  _trapFocus(event) {
    if (this.focusableElements.length === 0) return;

    const firstElement = this.focusableElements[0];
    const lastElement = this.focusableElements[this.focusableElements.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      }
    } else {
      if (document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  }

  updateFocusableElements() {
    this.focusableElements = Array.from(this.querySelectorAll('summary, button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
  }

  onOpen() {
    this.classList.add("select-input--open");

    if (this.activeIndex < 0) {
      this.setActiveIndex(0);
    } else {
      this.setActiveIndex(this.activeIndex);
    }

    setTimeout(() => {
      if (this.activeIndex >= 0 && this.optionButtons[this.activeIndex]) {
        this.optionButtons[this.activeIndex].focus();
      }
    }, 0);

    window.dispatchEvent(
      new CustomEvent("select-input:open", {
        detail: { target: this }
      })
    );
  }

  onClose() {
    this.classList.remove("select-input--open");
    this.summary.focus();
  }

  close() {
    this.details.open = false;
  }

  moveActiveIndex(direction) {
    let newIndex = this.activeIndex + direction;

    if (newIndex < 0) {
      newIndex = this.optionButtons.length - 1;
    } else if (newIndex >= this.optionButtons.length) {
      newIndex = 0;
    }

    this.setActiveIndex(newIndex);
  }

  setActiveIndex(index) {
    if (this.activeIndex >= 0 && this.optionButtons[this.activeIndex]) {
      this.optionButtons[this.activeIndex].classList.remove("select-input__option--active");
    }

    this.activeIndex = index;

    if (this.activeIndex >= 0 && this.optionButtons[this.activeIndex]) {
      const activeButton = this.optionButtons[this.activeIndex];
      activeButton.classList.add("select-input__option--active");
      activeButton.focus();

      activeButton.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  }

  selectActiveOption() {
    if (this.activeIndex >= 0 && this.optionButtons[this.activeIndex]) {
      const button = this.optionButtons[this.activeIndex];
      const value = button.dataset.value;
      const label = button.textContent.trim();

      this.selectOption(value, label);
    }
  }

  selectOption(value, label) {
    if (this.nativeSelect) {
      this.nativeSelect.value = value;

      const changeEvent = new Event("change", { bubbles: true });
      this.nativeSelect.dispatchEvent(changeEvent);
    }

    this.updateDisplay(value, label);

    this.optionButtons.forEach((button, index) => {
      if (button.dataset.value === value) {
        this.activeIndex = index;
      }
    });

    this.close();

    const selectEvent = new CustomEvent("select-change", {
      bubbles: true,
      detail: { value, label }
    });
    this.dispatchEvent(selectEvent);
  }

  updateDisplay(value, label) {
    if (!this.displayValue) return;

    if (!label) {
      const button = Array.from(this.optionButtons).find(btn => btn.dataset.value === value);
      label = button?.textContent.trim() || this.placeholder;
    }

    this.displayValue.textContent = label;

    if (value && value !== "") {
      this.classList.remove("select-input--empty");
      this.classList.add("is-selected");
    } else {
      this.classList.add("select-input--empty");
      this.classList.remove("is-selected");
      this.displayValue.textContent = this.placeholder;
    }
  }

  handleTypeAhead(key) {
    const startIndex = (this.activeIndex + 1) % this.optionButtons.length;

    for (let i = 0; i < this.optionButtons.length; i++) {
      const index = (startIndex + i) % this.optionButtons.length;
      const buttonText = this.optionButtons[index].textContent.trim().toLowerCase();

      if (buttonText.startsWith(key.toLowerCase())) {
        this.setActiveIndex(index);
        break;
      }
    }
  }
}

if (!customElements.get("select-input")) customElements.define("select-input", SelectInput);

class VideoElement extends HTMLElement {
  constructor() {
    super();

    this.desktopVideo = this.querySelector(".video-player--desktop");
    this.mobileVideo = this.querySelector(".video-player--mobile");
    this.playButton = this.querySelector("[data-play-button]");
    this.statusElement = this.querySelector("[data-video-status]");

    this.autoplay = this.dataset.autoplay === "true";
    this.loop = this.dataset.loop === "true";
    this.muted = this.dataset.muted === "true";
    this.hasMobileVideo = this.dataset.hasMobile === "true";

    this.currentVideo = null;
    this.isMobile = false;

    this._handlePlayButtonClick = this._handlePlayButtonClick.bind(this);
    this._handleKeydown = this._handleKeydown.bind(this);
    this._handleVideoPlay = this._handleVideoPlay.bind(this);
    this._handleVideoPause = this._handleVideoPause.bind(this);
    this._handleVideoEnded = this._handleVideoEnded.bind(this);
    this._handleResize = this._handleResize.bind(this);
  }

  connectedCallback() {
    this.checkViewport();
    this.setupEventListeners();

    if (this.autoplay && this.currentVideo) {
      this.currentVideo.play().catch(() => {
        this.updateState("paused");
      });
    } else {
      this.updateState("paused");
    }
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  checkViewport() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth < 768;

    const shouldUseMobile = this.isMobile && this.hasMobileVideo;
    const newVideo = shouldUseMobile ? this.mobileVideo : this.desktopVideo;

    if (newVideo !== this.currentVideo) {
      const wasPlaying = this.currentVideo && !this.currentVideo.paused;
      const currentTime = this.currentVideo ? this.currentVideo.currentTime : 0;

      this.currentVideo = newVideo;

      if (wasPlaying && this.currentVideo) {
        this.currentVideo.currentTime = currentTime;
        this.currentVideo.play();
      }
    }
  }

  setupEventListeners() {
    if (this.playButton) {
      this.playButton.addEventListener("click", this._handlePlayButtonClick);
      this.playButton.addEventListener("keydown", this._handleKeydown);
    }

    if (this.currentVideo) {
      this.currentVideo.addEventListener("play", this._handleVideoPlay);
      this.currentVideo.addEventListener("pause", this._handleVideoPause);
      this.currentVideo.addEventListener("ended", this._handleVideoEnded);
    }

    window.addEventListener("resize", this._handleResize);
  }

  removeEventListeners() {
    if (this.playButton) {
      this.playButton.removeEventListener("click", this._handlePlayButtonClick);
      this.playButton.removeEventListener("keydown", this._handleKeydown);
    }

    if (this.desktopVideo) {
      this.desktopVideo.removeEventListener("play", this._handleVideoPlay);
      this.desktopVideo.removeEventListener("pause", this._handleVideoPause);
      this.desktopVideo.removeEventListener("ended", this._handleVideoEnded);
    }

    if (this.mobileVideo) {
      this.mobileVideo.removeEventListener("play", this._handleVideoPlay);
      this.mobileVideo.removeEventListener("pause", this._handleVideoPause);
      this.mobileVideo.removeEventListener("ended", this._handleVideoEnded);
    }

    window.removeEventListener("resize", this._handleResize);
  }

  _handleResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.checkViewport();
    }, 150);
  }

  _handlePlayButtonClick(event) {
    event.preventDefault();
    this.togglePlay();
  }

  _handleKeydown(event) {
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      this.togglePlay();
    }
  }

  _handleVideoPlay() {
    this.updateState("playing");
    this.announceToScreenReader("Video playing");
  }

  _handleVideoPause() {
    this.updateState("paused");
    this.announceToScreenReader("Video paused");
  }

  _handleVideoEnded() {
    this.updateState("paused");
    this.announceToScreenReader("Video ended");
  }

  togglePlay() {
    if (!this.currentVideo) return;

    if (this.currentVideo.paused) {
      this.currentVideo.play().catch(error => {
        console.error("Error playing video:", error);
        this.announceToScreenReader("Unable to play video");
      });
    } else {
      this.currentVideo.pause();
    }
  }

  updateState(state) {
    this.setAttribute("data-state", state);

    if (this.playButton) {
      if (state === "playing") {
        this.playButton.setAttribute("aria-label", "Pause video");
      } else {
        this.playButton.setAttribute("aria-label", "Play video");
      }
    }
  }

  announceToScreenReader(message) {
    if (this.statusElement) {
      this.statusElement.textContent = message;
    }
  }
}
if (!customElements.get("video-element")) customElements.define("video-element", VideoElement);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector("swiper-container");
    this.debounceTimer = null;
    this.isUpdating = false;
    this.messageTimeout = null;
  }

  initCarousel() {
    if (!this.carousel) return;

    const recommendationsContainer = this.querySelector("[data-recommendations]");
    const prevBtn = recommendationsContainer?.querySelector("[data-swiper-prev]");
    const nextBtn = recommendationsContainer?.querySelector("[data-swiper-next]");

    Object.assign(this.carousel, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      grabCursor: true,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      breakpoints: {
        480: {
          slidesPerView: 1.65,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32
        }
      },
      on: {
        init: () => {
          this.carousel.classList.add("is-initialized");
          this.carousel.dataset.productsCount = this.carousel.querySelectorAll(".cart-drawer__recommendations-item").length;
          setTimeout(() => {
            this.updateNavButtons(prevBtn, nextBtn);
          }, 50);
        },
        slideChange: () => {
          this.updateNavButtons(prevBtn, nextBtn);
        },
        reachBeginning: () => {
          if (prevBtn) prevBtn.disabled = true;
        },
        reachEnd: () => {
          if (nextBtn) nextBtn.disabled = true;
        },
        fromEdge: () => {
          this.updateNavButtons(prevBtn, nextBtn);
        },
        touchStart: () => {
          document.body.classList.add("is-dragging-carousel");
        },
        touchEnd: () => {
          document.body.classList.remove("is-dragging-carousel");
        }
      }
    });

    this.carousel.initialize();

    // Bind navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        this.carousel.swiper?.slidePrev();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        this.carousel.swiper?.slideNext();
      });
    }
  }

  updateNavButtons(prevBtn, nextBtn) {
    const swiper = this.carousel?.swiper;
    if (!swiper) return;

    if (prevBtn) {
      prevBtn.disabled = swiper.isBeginning;
    }
    if (nextBtn) {
      nextBtn.disabled = swiper.isEnd;
    }
  }

  initEventListeners() {
    // Quantity buttons
    this.addEventListener("click", e => {
      const quantityBtn = e.target.closest("[data-quantity-btn]");
      if (quantityBtn) {
        e.preventDefault();
        this.handleQuantityButtonClick(quantityBtn);
      }

      const removeBtn = e.target.closest("[data-remove-item]");
      if (removeBtn) {
        e.preventDefault();
        this.handleRemoveItem(removeBtn);
      }
    });

    // Quantity input changes
    this.addEventListener("change", e => {
      const quantityInput = e.target.closest("[data-quantity-input]");
      if (quantityInput) {
        this.handleQuantityInputChange(quantityInput);
      }
    });

    // Add to cart form submissions (recommendations)
    this.addEventListener("submit", e => {
      const addToCartForm = e.target.closest("[data-add-to-cart-form]");
      if (addToCartForm) {
        e.preventDefault();
        this.handleAddToCart(addToCartForm);
      }
    });

    window.addEventListener("cart::update", async event => {
      await this.refreshCartDrawer(event.detail?.cartContents);
      // app.updateCartLeadTime();
      app.updateCartLeadTimeFromHTML();
      app.localizeLeadTimeElements();
      window.dispatchEvent(new CustomEvent("cart::open"));
      const cartMessage = event.detail?.cartMessage;
      this.showMessage(cartMessage);
    });
  }

  handleQuantityButtonClick(button) {
    const action = button.dataset.action;
    const quantityControls = button.closest("[data-quantity-controls]");
    const input = quantityControls.querySelector("[data-quantity-input]");
    const cartItem = button.closest("[data-cart-item]");
    const lineItemKey = cartItem.dataset.lineItemKey;

    if (action === "decrease") {
      input.stepDown();
    } else if (action === "increase") {
      input.stepUp();
    }

    const newQuantity = parseInt(input.value);
    this.updateCartItemDebounced(lineItemKey, newQuantity);
  }

  handleQuantityInputChange(input) {
    const cartItem = input.closest("[data-cart-item]");
    const lineItemKey = cartItem.dataset.lineItemKey;
    const newQuantity = parseInt(input.value);

    this.updateCartItemDebounced(lineItemKey, newQuantity);
  }

  handleRemoveItem(button) {
    const cartItem = button.closest("[data-cart-item]");
    const lineItemKey = cartItem.dataset.lineItemKey;

    this.updateCartItem(lineItemKey, 0);
  }

  async handleAddToCart(form) {
    if (this.isUpdating) return;
    this.isUpdating = true;

    // Add loading state
    this.classList.add("is-updating");

    const formData = new FormData(form);
    const variantId = formData.get("id");
    const quantity = formData.get("quantity") || 1;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: parseInt(quantity)
        })
      });

      if (!response.ok) {
        throw new Error("Add to cart failed");
      }

      await this.refreshCartDrawer();
      this.showMessage("added");
    } catch (error) {
      console.error("Error adding to cart:", error);
    } finally {
      this.isUpdating = false;
      this.classList.remove("is-updating");
    }
  }

  updateCartItemDebounced(lineItemKey, quantity) {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    this.debounceTimer = setTimeout(() => {
      this.updateCartItem(lineItemKey, quantity);
    }, 400);
  }

  async updateCartItem(lineItemKey, quantity) {
    if (this.isUpdating) return;
    this.isUpdating = true;

    const isRemoving = quantity === 0;

    // Add loading state
    this.classList.add("is-updating");

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: quantity
        })
      });

      if (!response.ok) {
        throw new Error("Cart update failed");
      }

      await this.refreshCartDrawer();

      if (isRemoving) {
        this.showMessage("removed");
      }
    } catch (error) {
      console.error("Error updating cart:", error);
      // Refresh anyway to show current state
      await this.refreshCartDrawer();
    } finally {
      this.isUpdating = false;
      this.classList.remove("is-updating");
    }
  }

  refreshCartDrawerScripts() {
    this.rebindCloseButton();
    this.loadRecommendations();
  }

  async refreshCartDrawer(cartContents) {
    try {
      if (cartContents) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(cartContents, "text/html");
        const newCartDrawer = doc.querySelector("cart-drawer");
        if (newCartDrawer) {
          if (app.latestLeadTimeStr) {
            app.updateLeadTimeUI(app.latestLeadTimeStr, newCartDrawer);
          }
          this.innerHTML = newCartDrawer.innerHTML;
          this.refreshCartDrawerScripts();
          // app.updateCartLeadTime();
          app.updateCartLeadTimeFromHTML();
        }

        // Update header cart count
        const newCount = doc.querySelector("[data-cart-items-count]");
        const currentCount = document.querySelector("[header-cart-count]");
        if (newCount && currentCount) {
          currentCount.textContent = newCount.getAttribute("data-cart-items-count");
        }
      } else {
        const response = await fetch(`${window.location.pathname}?sections=header-main`);
        const data = await response.json();

        if (data["header-main"]) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data["header-main"], "text/html");
          const newCartDrawer = doc.querySelector("cart-drawer");

          if (newCartDrawer) {
            if (app.latestLeadTimeStr) {
              app.updateLeadTimeUI(app.latestLeadTimeStr, newCartDrawer);
            }
            // Preserve the carousel state by copying innerHTML
            const newInnerHTML = newCartDrawer.innerHTML;
            this.innerHTML = newInnerHTML;
            this.refreshCartDrawerScripts();
            // app.updateCartLeadTime();
            app.updateCartLeadTimeFromHTML();
          }

          // Update header cart count
          const newCount = doc.querySelector("[data-cart-items-count]");
          const currentCount = document.querySelector("[header-cart-count]");
          if (newCount && currentCount) {
            currentCount.textContent = newCount.getAttribute("data-cart-items-count");
          }
        }
      }
    } catch (error) {
      console.error("Error refreshing cart drawer:", error);
    }
  }

  rebindCloseButton() {
    const drawerElement = this.closest("drawer-element");
    if (drawerElement) {
      const closeButton = this.querySelector("[drawer-close]");
      if (closeButton) {
        closeButton.addEventListener("click", e => {
          e.stopPropagation();
          e.preventDefault();
          drawerElement.close();
        });
      }
    }
  }

  setupRecommendationsOnOpen() {
    const drawerElement = this.closest("drawer-element");
    const trigger = drawerElement?.querySelector("[drawer-trigger]");
    if (trigger) {
      trigger.addEventListener("click", () => this.loadRecommendations());
    }
  }

  async loadRecommendations() {
    const recommendationsContainer = this.querySelector("[data-recommendations]");
    if (!recommendationsContainer) return;

    const productIds = recommendationsContainer.dataset.productIds;
    const productIdsInCart = recommendationsContainer.dataset.productIdsInCart.split(",").map(id => id.trim());
    const limit = parseInt(recommendationsContainer.dataset.limit) || 6;
    const addLabel = recommendationsContainer.dataset.addLabel || "Add";

    if (!productIds) return;

    const productIdArray = productIds.split(",").map(id => id.trim());
    const allRecommendations = [];
    const seenProductIds = new Set(productIdsInCart);

    // Fetch recommendations for each product in cart
    for (const productId of productIdArray) {
      try {
        const response = await fetch(`${window.routes.recommendations_url}/products.json?product_id=${productId}&limit=4&intent=complementary`);

        if (!response.ok) continue;

        const data = await response.json();

        if (data.products && data.products.length > 0) {
          for (const product of data.products) {
            // Skip if already in cart or already added to recommendations
            if (!seenProductIds.has(String(product.id))) {
              seenProductIds.add(String(product.id));
              allRecommendations.push(product);
            }
          }
        }
      } catch (error) {
        console.error(`Error fetching recommendations for product ${productId}:`, error);
      }

      // Stop if we have enough recommendations
      if (allRecommendations.length >= limit) break;
    }

    // Limit to max number
    const recommendations = allRecommendations.slice(0, limit);

    if (recommendations.length === 0) {
      recommendationsContainer.style.display = "none";
      return;
    }

    // Render recommendations
    this.renderRecommendations(recommendationsContainer, recommendations, addLabel);
  }

  renderRecommendations(container, products, addLabel) {
    const swiperContainer = container.querySelector("swiper-container");
    if (!swiperContainer) return;

    const slidesHTML = products
      .map(product => {
        const variantId = product.variants[0]?.id;
        const price = window.theme.formatMoney(product.price);
        const imageUrl = product.featured_image ? product.featured_image.replace(/\.([^.]+)$/, "_200x.$1") : "";
        const fabricPlaceholder = container.dataset.fabricPlaceholder;
        const fabricTitle = product.variants[0].option1 || null;
        const fabricText = fabricTitle && (product.type == "Furniture" || product.type == "Furniture - hard") ? fabricPlaceholder.replace("#fabric#", fabricTitle) : null;

        return `
        <swiper-slide>
          <div class="cart-drawer__recommendations-item">
            <a class="cart-drawer__recommendations-item-image-link" href="${product.url}">
              ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" width="100" height="auto">` : ""}
            </a>
            <div class="cart-drawer__recommendations-item-content">
              <a class="t-bold t-small" href="${product.url}">${product.title}</a>
              ${
                fabricText
                  ? `
              <span class="cart-drawer__recommendations-item-fabric t-xsmall c-gray">${fabricText}</span>
              `
                  : ""
              }
              <form action="/cart/add" method="post" data-add-to-cart-form>
                <input type="hidden" name="id" value="${variantId}">
                <input type="hidden" name="quantity" value="1">
                <button type="submit" class="btn btn--link btn--link-small" data-add-to-cart-btn>
                  <span>+ ${addLabel}</span>
                </button>
              </form>
            </div>
            <div class="cart-drawer__recommendations-item-price">
              <p class="t-small t-bold">${price}</p>
            </div>
          </div>
        </swiper-slide>
      `;
      })
      .join("");

    swiperContainer.innerHTML = slidesHTML;

    // Show the container and initialize carousel
    container.style.display = "";
    this.carousel = swiperContainer;
    this.initCarousel();
  }

  showMessage(type) {
    // Hide any existing messages first
    const allMessages = this.querySelectorAll("[data-added-to-cart-message], [data-removed-from-cart-message], [data-samples-added-to-cart-message]");
    allMessages.forEach(msg => msg.classList.remove("is-visible"));

    // Clear any existing timeout
    if (this.messageTimeout) {
      clearTimeout(this.messageTimeout);
    }

    // Show the appropriate message
    let selector = "";
    switch (type) {
      case "added":
        selector = "[data-added-to-cart-message]";
        break;
      case "removed":
        selector = "[data-removed-from-cart-message]";
        break;
      case "samples_added":
        selector = "[data-samples-added-to-cart-message]";
        break;
    }
    const message = this.querySelector(selector);

    if (message) {
      message.classList.add("is-visible");

      // Hide after 3 seconds
      this.messageTimeout = setTimeout(() => {
        message.classList.remove("is-visible");
      }, 3000);
    }
  }

  connectedCallback() {
    this.initEventListeners();
    this.setupRecommendationsOnOpen();
  }
}
if (!customElements.get("cart-drawer")) customElements.define("cart-drawer", CartDrawer);

class HeaderPredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("[data-input]");
    this.resultsContainer = this.querySelector("[data-results]");
    this.openTriggers = document.querySelectorAll("[data-open-search]");
    this.closeTriggers = this.querySelectorAll("[data-close]");
    this.debounceTimer = null;
  }

  connectedCallback() {
    this.initEventListeners();
  }

  open() {
    this.setAttribute("data-is-open", "true");
    this.input.focus();
  }

  close() {
    this.setAttribute("data-is-open", "false");
  }

  handleSearch() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);

    // Clear results if input is empty
    if (this.input.value.trim() === "") {
      this.resultsContainer.innerHTML = "";
      return;
    }

    this.debounceTimer = setTimeout(() => {
      fetch(`${routes.search_url}?type=product&q=${this.input.value}&view=predictive`)
        .then(response => response.text())
        .then(content => {
          const tmp = document.createElement("div");
          tmp.innerHTML = content;

          // Get all .search__result elements
          const allResults = tmp.querySelectorAll(".search__result");

          // Get total results count from data-results-count attribute
          const searchResultsContainer = tmp.querySelector(".search__results");
          const totalResultsCount = searchResultsContainer ? searchResultsContainer.dataset.resultsCount : allResults.length;

          // Take only the first 6
          const firstFiveResults = Array.from(allResults).slice(0, 6);

          // Clear the results container
          this.resultsContainer.innerHTML = "";

          // Add the first 5 results to the container
          if (firstFiveResults.length > 0) {
            const resultsGridElement = document.createElement("div");
            resultsGridElement.className = "header-search__results-grid";
            firstFiveResults.forEach(result => {
              resultsGridElement.appendChild(result);
            });
            this.resultsContainer.appendChild(resultsGridElement);
          } else {
            const noResultsElement = document.createElement("div");
            noResultsElement.className = "header-search__no-results t-small";
            noResultsElement.textContent = window.messages.search_no_results;
            this.resultsContainer.appendChild(noResultsElement);
          }

          // If there are more than 6 results, add a "see all" link
          if (allResults.length > 6) {
            const seeAllContainer = document.createElement("div");
            seeAllContainer.className = "header-search__more-btn-hld";
            const seeAllLink = document.createElement("a");
            seeAllLink.href = `${routes.search_url}?q=${encodeURIComponent(this.input.value)}`;
            seeAllLink.className = "header-search__more-btn btn btn--link";
            seeAllLink.textContent = `${window.messages.see_all_products} (${totalResultsCount})`;
            seeAllContainer.appendChild(seeAllLink);
            this.resultsContainer.appendChild(seeAllContainer);
          }
        })
        .catch(error => {
          console.error("Error fetching search results:", error);
        });
    }, 400);
  }

  initEventListeners() {
    if (this.openTriggers.length > 0) {
      this.openTriggers.forEach(trigger => {
        trigger.addEventListener("click", e => {
          e.preventDefault();
          this.open();
        });
      });
    }

    if (this.closeTriggers.length > 0) {
      this.closeTriggers.forEach(trigger => {
        trigger.addEventListener("click", e => {
          e.preventDefault();
          this.close();
        });
      });
    }

    // search with a debounced function
    this.input.addEventListener("input", this.handleSearch.bind(this));

    document.addEventListener("keydown", e => {
      if (e.key === "Escape" && this.getAttribute("data-is-open") === "true") {
        this.close();
      }
    });
  }
}
if (!customElements.get("header-predictive-search")) customElements.define("header-predictive-search", HeaderPredictiveSearch);

class OpenGorgias extends HTMLElement {
  constructor() {
    super();
  }

  initEventListeners() {
    this.addEventListener("click", function () {
      GorgiasChat.open();
    });
  }

  connectedCallback() {
    this.initEventListeners();
  }
}
if (!customElements.get("open-gorgias")) customElements.define("open-gorgias", OpenGorgias);
